import api from '@/services/api'

export default () => {
    const userType = api.clientData('user_type')
    return userType == 1 || userType == 6
}